import { VBAR_GROUPS, FIVE_MINUTES_EVENT_TYPES } from '@/utils/constants/commons'
export default {
  computed: {
    isVbarEvent() {
      return this.event && VBAR_GROUPS.includes(this.event.online_event_type)
    },
    isFiveMinutesEvent() {
      return this.event && FIVE_MINUTES_EVENT_TYPES.includes(this.event.online_event_type)
    },
    isOnlineServiceLinktextEvent() {
      return this.event && this.event.online_event_type === 'online_service_linktext'
    },
    isScrapedOnlineEvent() {
      return this.event && this.event.online_event_type === 'scraped_online_event'
    },
    isOnlineEvent() {
      return this.event && this.event.online_event_type !== 'offline'
    }
  }
}
